var map = {
	"./sofa_black.png": 408,
	"./sofa_blue.png": 928,
	"./sofa_cream.png": 447,
	"./sofa_cyan.png": 510,
	"./sofa_pink.png": 762,
	"./sofa_purple.png": 466,
	"./sofa_white.png": 940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 555;